import { ReactElement } from 'react'
import { useSnowLoadAssignment } from '@scene'
import LiveLoadIcon from '../LiveLoadIcon'
import useLiveLoadMetadata from '../hooks/useLiveLoadMetadata'

interface Props {
  slab: ShapeObject
  color?: string
  opacity?: number
}

const LiveLoadIndicator = ({ slab, color, opacity }: Props): ReactElement => {
  const { hasSnowLoad } = useSnowLoadAssignment({ slab })
  const {
    liveLoadDisabled: hasLiveLoad,
    pointForIcon,
    rotation,
  } = useLiveLoadMetadata({
    slab,
    offsetX: hasSnowLoad ? 0.6 : 0.3,
  })

  return (
    <LiveLoadIcon
      hasLiveLoad={hasLiveLoad}
      pointForIcon={pointForIcon}
      color={color}
      rotation={rotation}
      opacity={opacity}
    />
  )
}

export default LiveLoadIndicator
